const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";
const FINE_POINTER_QUERY = "(hover: hover) and (pointer: fine)";
/**
 * The browser adapter behind `MediaPreferencesPort` — the composition root
 * (`system/pwa/src/main.ts`) constructs this instead of `client/ui`'s `shell/pmenu.ts` /
 * `stages/waves-stage.ts` / `stages/waves-canvas.ts` calling `matchMedia` inline, keeping
 * browser I/O out of `client/ui` (boundary rule B2) the same way `BrowserThemeEnvironment`
 * keeps `localStorage`/`matchMedia` out of `shell/theme-init.ts`.
 *
 * Every read is wrapped in try/catch and defaults to `false`: `matchMedia` throws on a
 * malformed query string in some engines, and both call sites treat `false` as the safe
 * answer (full motion, no hover affordance). See `MediaPreferencesPort`'s own doc comment
 * for why this is a separate port from `ThemeEnvironmentPort` despite sharing a global.
 */
export class BrowserMediaPreferences {
    #matchMedia;
    constructor(options = {}) {
        this.#matchMedia = options.matchMedia ??
            (typeof globalThis.matchMedia === "function" ? globalThis.matchMedia.bind(globalThis) : undefined);
    }
    prefersReducedMotion() {
        return this.#matches(REDUCED_MOTION_QUERY);
    }
    hasFinePointer() {
        return this.#matches(FINE_POINTER_QUERY);
    }
    #matches(query) {
        if (!this.#matchMedia)
            return false;
        try {
            return this.#matchMedia(query).matches;
        }
        catch {
            return false;
        }
    }
}
export function createBrowserMediaPreferences(options = {}) {
    return new BrowserMediaPreferences(options);
}
//# sourceMappingURL=browser-media-preferences.js.map